class SimpleEventBus {
    constructor() {
        Object.defineProperty(this, "handlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    on(event, handler) {
        const listeners = this.handlers.get(event) ?? new Set();
        listeners.add(handler);
        this.handlers.set(event, listeners);
        console.log('[EventBus] Handler registered', {
            event,
            listenerCount: listeners.size
        });
    }
    off(event, handler) {
        const listeners = this.handlers.get(event);
        if (!listeners) {
            return;
        }
        listeners.delete(handler);
        if (listeners.size === 0) {
            this.handlers.delete(event);
        }
        console.log('[EventBus] Handler removed', {
            event,
            remainingListeners: this.handlers.get(event)?.size ?? 0
        });
    }
    emit(event, payload) {
        const listeners = this.handlers.get(event);
        if (!listeners) {
            console.log('[EventBus] No listeners for event', {
                event,
                payload
            });
            return;
        }
        console.log('[EventBus] Emitting event', {
            event,
            listenerCount: listeners.size,
            payload
        });
        for (const listener of listeners) {
            listener(payload);
        }
    }
}
const eventBus = new SimpleEventBus();
export default eventBus;
